@let isMenuPage = pageIs().menu;
@let isNewOnTapPage = pageIs().newOnTap;
@let isServicesPage = pageIs().services;
@let isMorePage = pageIs().more;

<div
  class="tab-bar"
  [class.hide]="hideTabBar()"
>
  <div class="tabs" coreActivitySection="TabBar">
    <button
      class="tab"
      style="min-width: 194px"
      [class.active]="isMenuPage"
      [routerLink]="isMenuPage ? '/main/home' : '/main/menu'"
      [coreUserActivityClickTracking]="isMenuPage ? 'MenuClose' : 'MenuOpen'"
    >
      <img class="icon" src="/images/tab-bar/menu.svg" alt="Menu" width="64" height="63"/>
      <div class="label">Menu</div>
    </button>

    <button
      class="tab"
      [class.active]="isNewOnTapPage"
      [routerLink]="isNewOnTapPage ? '/main/home' : '/main/new-on-tap'"
      [coreUserActivityClickTracking]="isNewOnTapPage ? 'NewOnTapPageClose' : 'NewOnTapPageOpen'"
    >
      <img class="icon" src="/images/tab-bar/bear.svg" alt="Bear" width="64" height="63"/>
      <div class="label">New on tap</div>
    </button>

    <button
      class="tab"
      [class.active]="isServicesPage"
      [routerLink]="isServicesPage ? '/main/home' : '/main/services'"
      [coreUserActivityClickTracking]="isServicesPage ? 'ServicesPageClose' : 'ServicesPageOpen'"
    >
      <img class="icon" src="/images/tab-bar/services.svg" alt="Services" width="64" height="63"/>
      <div class="label">Service</div>
      <app-call-waiter-indicator class="indicator"/>
    </button>
    <button
      class="tab"
      [class.active]="isMorePage"
      [routerLink]="isMorePage ? '/main/home' : '/main/more'"
      [coreUserActivityClickTracking]="isMorePage ? 'MorePageClose' : 'MorePageOpen'"
    >
      <img class="icon" src="/images/tab-bar/more.svg" alt="More" width="64" height="63"/>
      <div class="label">More</div>
    </button>
  </div>
</div>

@if (hideTabBar()) {
  <core-interacts-present/>
}
